import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    fragmentContainer: {
        // marginTop: '10px',
        width: '100%',
        paddingTop:'10px',
        paddingLeft:'5px',
        paddingRight:'5px',
        flexDirection: 'row'
    },
    label: {
        width: '100%',
        fontSize: 10
    },
});

  const Seller = ({invoice}) => (
    <>
        <View style={styles.fragmentContainer}>
            <Text key={'company'} style={styles.label}>
                Prezado Senhor(a), Agradecemos seu interesse em nossos produtos e conforme solicitado informamos nossos preços e
                demais condições para fornecimento dos seguintes itens.
                <br/>
            </Text>
        </View>
    </>
  );
  
  export default Seller